<div class="col-sm-12 margin-left-40 margin-top-20 padding-right-20">
    <div class="radio">
        <label>
            <span *ngIf="answer.IsCorrect">
                <input #myradio (click)="showCorrectAnswer()" type="radio" class="colored-success answerRadioBtn">
            </span>
            <span *ngIf="!answer.IsCorrect">
                <input #myradio (click)="showIncorrectAnswer()" type="radio" class="colored-danger answerRadioBtn">
            </span>
            <span class="text">{{answer.AnswerText}}</span>
        </label>
    </div>
    <div class="alert alert-success margin-right-50 margin-top-10" [ngStyle]="{display : getCorrectStyle()}">
        <strong>Correct</strong><span> {{answer.AnswerExplanation}}</span>
    </div>
    <div class="alert alert-danger margin-right-50 margin-top-10" [ngStyle]="{display : getIncorrectStyle()}">
        <strong>Incorrect!</strong><span> {{answer.AnswerExplanation}}</span>
    </div>
</div>
